import {SettingsCustomFieldsPagesEnum} from '../../../../models/url/settingsUrlModel';
import {
  AccountResult,
  baseMethods,
  ConvertMethod,
  EmailResult,
  GetCustomField,
  ResultType,
  ResultTypesEnum,
  StringResult,
  TeammateResult,
} from './internal';

export const contactType: ResultType = {
  name: ResultTypesEnum.CONTACT,
  properties: {
    id: StringResult,
    name: StringResult,
    email: EmailResult,
    phone: StringResult,
    twitter: StringResult,
    handle: StringResult,
    account: AccountResult,
  },
  methods: {
    get_custom_field: new GetCustomField(SettingsCustomFieldsPagesEnum.CARDS),
    to_teammate: new ConvertMethod(TeammateResult),
    ...baseMethods,
  },
};
